export const genres = [
  {
    id: "family",
    name: "家庭伦理",
    icon: "ri-home-heart-line",
    tagline: "血缘、代际与原生家庭的隐形秩序",
    description:
      "这类作品把镜头对准客厅与餐桌，聚焦父权结构、代际冲突、赡养与遗产、隐藏多年的家庭秘密。冲突往往不在外部事件，而在亲密的人之间如何互相消耗与和解。",
    highlights: [
      "父辈权威的松动与子女的反叛",
      "原生家庭创伤如何传递到下一代",
      "赡养、照护与「谁来负责」的现实困境",
      "遗产与亲情之间难以两全的取舍",
    ],
  },
  {
    id: "marriage",
    name: "婚姻与情感",
    icon: "ri-links-line",
    tagline: "从相爱到相看两厌的完整轨迹",
    description:
      "婚姻题材几乎定义了欧美伦理片的主舞台：出轨、七年之痒、共同生活的耗损、离婚的拉扯。影片通常不急着审判谁对谁错，而是让观众看见关系如何在日常里缓慢变形。",
    highlights: [
      "亲密关系的倦怠与重新谈判",
      "出轨作为症状，而非单纯道德过失",
      "离婚诉讼中的表演、博弈与自我辩护",
      "中年危机里的自我价值追问",
    ],
  },
  {
    id: "forbidden",
    name: "禁忌之爱",
    icon: "ri-forbid-2-line",
    tagline: "被规则划出边界的关系如何被讲述",
    description:
      "年龄差、师生、婚外、跨阶层的越界关系，是伦理片反复回访的禁区。优秀作品通常不以猎奇为目的，而是借越界凝视社会规范本身：这些规则保护了谁，又压抑了谁。",
    highlights: [
      "权力不对等关系中难以界定的「自愿」",
      "社会规范与个人欲望的正面冲撞",
      "越界之后的代价与自我认知重塑",
      "叙事视角如何决定观众的同理对象",
    ],
  },
  {
    id: "youth",
    name: "青春期与成长",
    icon: "ri-seedling-line",
    tagline: "性意识觉醒与身份认同的迟到解释",
    description:
      "成长题材记录一个人第一次面对欲望、身体与自我定位的时刻。它常与家庭伦理交织：孩子如何在父母的目光与同龄人的压力之间，学会成为自己。",
    highlights: [
      "初次心动与身体意识的萌发",
      "性别认同与性取向的自我确认",
      "与父母控制欲之间的拉锯",
      "友情、排挤与青春期的权力游戏",
    ],
  },
  {
    id: "urban",
    name: "都市欲望",
    icon: "ri-building-line",
    tagline: "中产焦虑、物质丰裕后的精神空心",
    description:
      "当房子、事业与体面都已到手，人反而失去了方向。都市题材把镜头对准看似成功者的内部：孤独、攀比、情感交易与意义的缺席。",
    highlights: [
      "物质丰裕与精神空洞的落差",
      "城市孤独症与无法亲近的亲密感",
      "职场伦理中的妥协与自我出卖",
      "消费主义塑造的欲望结构",
    ],
  },
  {
    id: "moral",
    name: "道德困境与罪罚",
    icon: "ri-scales-3-line",
    tagline: "正义模糊地带里没有干净的答案",
    description:
      "复仇、背叛、沉默与共谋构成影片的伦理实验室。它们迫使观众面对一个问题：如果身处同样的处境，我们真的会做出更好的选择吗？",
    highlights: [
      "复仇是否真的能终结伤害",
      "旁观者的沉默算不算共谋",
      "法律判决与道德评价之间的落差",
      "宽恕与惩罚之间需要多大的勇气",
    ],
  },
];